/*
 * Курс «Нейросети для работы и жизни» — доменные шаги.
 *
 * ⛔ Ни один шаг не зовёт нейросеть: работа модели — наши деньги
 * (память feedback_no_free_work_we_pay_for_2026_10_02). Все «ответы
 * нейросети» в курсе — примеры, написанные для урока, и подписаны так на
 * экране. Настоящая генерация — в наших тулах, куда ведёт `tool-task`.
 *
 * Типы:
 *   prompt-build — собрать запрос из кусочков; проверка — по меткам кусочков
 *                  (роль, задача, контекст, формат, ограничения, пример, тон, лишнее);
 *   prompt-fix   — выбрать правку слабого запроса, затем «было → стало»;
 *   spot-claims  — отметить предложения, которым нельзя верить без проверки
 *                  (или которые нельзя отправлять в чат-бот) — метки в данных;
 *   ai-or-human  — по одному тексту: «похоже на ИИ / на человека» с разбором;
 *   tool-task    — задание в нашем туле (первый доступный на этой половине
 *                  сайта из `tools`), иначе — то же задание без тула.
 * Тексты интерфейса — `ui` в resources/lang/{locale}/tools/ai-course.php,
 * карта тулов страницы — window.__AI_COURSE_TOOLS (блейд, tool_linkable_here).
 */
(function () {
    'use strict';
    var K = window.CourseKit;
    if (!K) return;

    var TOOLS = window.__AI_COURSE_TOOLS || {};

    function T(step) { return step.t || {}; }

    function prompt(host, api, text) {
        if (text) host.appendChild(api.richEl('p', 'crs-prompt', text));
    }

    function exampleCard(api, label, text, cls) {
        var box = api.el('div', 'ai-card' + (cls ? ' ' + cls : ''));
        box.appendChild(api.el('span', 'ai-card-k', label));
        box.appendChild(api.richEl('div', 'ai-card-tx', text));
        return box;
    }

    function tagName(api, tag) { return api.tt('tag_' + tag); }

    /* ── собрать запрос из кусочков ─────────────────────────────────── */
    K.step('prompt-build', {
        mount: function (host, step, api) {
            var t = T(step);
            var labels = t.chips || [];
            var tags = step.chips || [];
            var need = step.need || [];
            prompt(host, api, t.prompt);
            api.figure(host);
            host.appendChild(api.el('p', 'crs-hint', api.tt('pb_hint')));

            var out = api.el('div', 'ai-card ai-built');
            out.appendChild(api.el('span', 'ai-card-k', api.tt('pb_your')));
            var built = api.el('div', 'ai-built-tx');
            out.appendChild(built);
            host.appendChild(out);

            var pool = api.el('div', 'crs-chips');
            host.appendChild(pool);
            var picked = [];
            var chips = {};
            var locked = false;
            api.shuffle(labels.map(function (_, i) { return i; })).forEach(function (i) {
                var c = api.el('button', 'crs-chip');
                c.type = 'button';
                c.innerHTML = api.rich(labels[i]);
                c.addEventListener('click', function () {
                    if (locked) return;
                    var at = picked.indexOf(i);
                    if (at >= 0) picked.splice(at, 1); else picked.push(i);
                    draw();
                });
                chips[i] = c;
                pool.appendChild(c);
            });
            var check = api.el('div', 'ai-check');
            host.appendChild(check);

            function draw() {
                built.innerHTML = '';
                if (!picked.length) built.appendChild(api.el('span', 'ai-empty', api.tt('pb_empty')));
                picked.forEach(function (i) {
                    var s = api.el('span', 'ai-piece');
                    s.innerHTML = api.rich(labels[i]);
                    built.appendChild(s);
                    built.appendChild(document.createTextNode(' '));
                });
                Object.keys(chips).forEach(function (k) {
                    var on = picked.indexOf(+k) >= 0;
                    chips[k].classList.toggle('is-sel', on);
                    chips[k].setAttribute('aria-pressed', on ? 'true' : 'false');
                });
                api.primaryEnabled(picked.length > 0);
            }

            function plainText() {
                return picked.map(function (i) { return String(labels[i]).replace(/\*\*/g, ''); }).join(' ');
            }

            api.primary(api.t('check'), function () {
                locked = true;
                var have = {};
                var extra = [];
                picked.forEach(function (i) {
                    var tg = tags[i] || 'noise';
                    if (tg === 'noise' || need.indexOf(tg) < 0) extra.push(labels[i]);
                    else have[tg] = true;
                });
                var missing = need.filter(function (tg) { return !have[tg]; });
                var hit = need.length - missing.length;
                var score = need.length ? Math.max(0, (hit - extra.length * 0.5) / need.length) : 1;
                var ok = missing.length === 0 && extra.length === 0;

                check.innerHTML = '';
                var ul = api.el('ul', 'ai-checklist');
                need.forEach(function (tg) {
                    var li = api.el('li', have[tg] ? 'is-ok' : 'is-miss', (have[tg] ? '✓ ' : '✗ ') + tagName(api, tg));
                    ul.appendChild(li);
                });
                check.appendChild(ul);
                Object.keys(chips).forEach(function (k) {
                    var i = +k;
                    if (picked.indexOf(i) < 0) {
                        if (need.indexOf(tags[i]) >= 0 && !have[tags[i]]) chips[k].classList.add('is-hint');
                        return;
                    }
                    var good = tags[i] !== 'noise' && need.indexOf(tags[i]) >= 0;
                    chips[k].classList.add(good ? 'is-right' : 'is-wrong');
                });
                if (picked.length) {
                    var copy = api.el('button', 'lg-btn lg-btn-ghost lg-btn-sm', '📋 ' + api.tt('pb_copy'));
                    copy.type = 'button';
                    copy.addEventListener('click', function () {
                        var txt = plainText();
                        var done = function () { copy.textContent = '✓ ' + api.tt('pb_copied'); };
                        try {
                            if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(txt).then(done, function () {});
                        } catch (_) {}
                    });
                    check.appendChild(copy);
                }
                var reveal = [];
                if (missing.length) reveal.push(api.tt('pb_missing') + ' ' + missing.map(function (tg) { return tagName(api, tg); }).join(', '));
                if (extra.length) reveal.push(api.tt('pb_extra') + ' ' + extra.map(function (x) { return '«' + String(x).replace(/\*\*/g, '') + '»'; }).join(', '));
                api.answer({ correct: ok, score: score, reveal: reveal.length ? reveal.join('\n') : null });
            }, true);
            draw();
        }
    });

    /* ── слабый запрос → какая правка поможет → было/стало ──────────── */
    K.step('prompt-fix', {
        mount: function (host, step, api) {
            var t = T(step);
            prompt(host, api, t.prompt);
            if (t.weak) host.appendChild(exampleCard(api, api.tt('pf_weak'), t.weak, 'ai-q'));
            if (t.weak_out) host.appendChild(exampleCard(api, api.tt('pf_out'), t.weak_out, 'ai-a'));
            var opts = t.options || [];
            var order = opts.map(function (_, i) { return i; });
            if (step.shuffle !== false) order = api.shuffle(order);
            var list = api.el('div', 'crs-opts');
            var buttons = [];
            var after = api.el('div', 'ai-after');
            var done = false;
            order.forEach(function (oi, pos) {
                var b = api.el('button', 'crs-opt');
                b.type = 'button';
                b.setAttribute('data-i', oi);
                b.appendChild(api.el('span', 'crs-opt-n', String(pos + 1)));
                b.appendChild(api.richEl('span', null, opts[oi]));
                b.addEventListener('click', function () { pick(oi); });
                buttons.push(b);
                list.appendChild(b);
            });
            host.appendChild(list);
            host.appendChild(after);
            function pick(i) {
                if (done) return;
                done = true;
                var ok = i === step.answer;
                buttons.forEach(function (b) {
                    var k = +b.getAttribute('data-i');
                    b.disabled = true;
                    if (k === step.answer) b.classList.add('is-right');
                    else if (k === i) b.classList.add('is-wrong');
                });
                if (t.better) after.appendChild(exampleCard(api, api.tt('pf_better'), t.better, 'ai-q ai-good'));
                if (t.better_out) after.appendChild(exampleCard(api, api.tt('pf_better_out'), t.better_out, 'ai-a ai-good'));
                if (step.after_figure) api.figure(after, step.after_figure);
                var why = t.why && t.why[i] ? t.why[i] : null;
                api.answer({ correct: ok, reveal: ok ? null : opts[step.answer], explain: [why, t.explain].filter(Boolean).join('\n\n') || null });
            }
            api.onKey(function (k) {
                var n = parseInt(k, 10);
                if (n >= 1 && n <= buttons.length) { buttons[n - 1].click(); return true; }
                return false;
            });
        }
    });

    /* ── отметить предложения: выдумку, непроверяемое, лишнее для чат-бота ── */
    K.step('spot-claims', {
        mount: function (host, step, api) {
            var t = T(step);
            var sents = t.sentences || [];
            var flags = step.flags || [];
            prompt(host, api, t.prompt);
            host.appendChild(api.el('p', 'crs-hint', t.hint || api.tt('sc_hint')));
            var card = api.el('div', 'ai-card ai-a');
            card.appendChild(api.el('span', 'ai-card-k', t.label || api.tt('sc_label')));
            var body = api.el('div', 'ai-card-tx ai-sents');
            card.appendChild(body);
            host.appendChild(card);
            var picked = {};
            var spans = [];
            var locked = false;
            sents.forEach(function (s, i) {
                var b = api.el('button', 'ai-sent');
                b.type = 'button';
                b.setAttribute('aria-pressed', 'false');
                b.innerHTML = api.rich(s);
                b.addEventListener('click', function () {
                    if (locked) return;
                    picked[i] = !picked[i];
                    b.classList.toggle('is-sel', !!picked[i]);
                    b.setAttribute('aria-pressed', picked[i] ? 'true' : 'false');
                    api.primaryEnabled(Object.keys(picked).some(function (k) { return picked[k]; }));
                });
                spans.push(b);
                body.appendChild(b);
                body.appendChild(document.createTextNode(' '));
            });
            var notes = api.el('ul', 'ai-notes');
            host.appendChild(notes);
            api.primary(api.t('check'), function () {
                locked = true;
                var pos = 0, tp = 0, fp = 0, fn = 0;
                sents.forEach(function (_, i) {
                    var f = !!flags[i], p = !!picked[i];
                    if (f) pos++;
                    var cls = f && p ? 'is-right' : (f && !p ? 'is-missed' : (!f && p ? 'is-wrong' : ''));
                    if (f && p) tp++; else if (f && !p) fn++; else if (!f && p) fp++;
                    if (cls) spans[i].classList.add(cls);
                    spans[i].disabled = true;
                    if ((f || p) && t.why && t.why[i]) {
                        var lead = f && p ? api.tt('sc_caught') : (f ? api.tt('sc_missed') : api.tt('sc_false'));
                        var li = api.el('li', f ? (p ? 'is-ok' : 'is-miss') : 'is-false');
                        li.innerHTML = '<b>' + api.rich(lead) + '</b> ' + api.rich(t.why[i]);
                        notes.appendChild(li);
                    }
                });
                var score = pos ? Math.max(0, (tp - fp * 0.5) / pos) : 1;
                api.answer({ correct: fn === 0 && fp === 0, score: score });
            }, true);
        }
    });

    /* ── похоже на ИИ или на человека ───────────────────────────────── */
    K.step('ai-or-human', {
        mount: function (host, step, api) {
            var t = T(step);
            var items = t.items || [];
            var truth = step.answers || [];
            prompt(host, api, t.prompt);
            var count = api.el('p', 'crs-hint');
            var card = api.el('div', 'ai-card ai-a');
            var tx = api.el('div', 'ai-card-tx');
            card.appendChild(tx);
            var row = api.el('div', 'crs-rapid-row');
            var bAi = api.el('button', 'lg-btn lg-btn-ghost', '🤖 ' + api.tt('ah_ai'));
            var bHu = api.el('button', 'lg-btn lg-btn-ghost', '🧑 ' + api.tt('ah_human'));
            bAi.type = bHu.type = 'button';
            row.appendChild(bAi);
            row.appendChild(bHu);
            var verdict = api.el('div', 'ai-verdict');
            var next = api.el('button', 'lg-btn lg-btn-sm ai-next', api.tt('ah_next'));
            next.type = 'button';
            next.hidden = true;
            host.appendChild(count);
            host.appendChild(card);
            host.appendChild(row);
            host.appendChild(verdict);
            host.appendChild(next);
            var i = 0, right = 0, busy = false;
            function show() {
                busy = false;
                count.textContent = api.fmt(api.tt('ah_count'), { n: i + 1, total: items.length });
                tx.innerHTML = api.rich(items[i] || '');
                verdict.innerHTML = '';
                verdict.className = 'ai-verdict';
                bAi.disabled = bHu.disabled = false;
                next.hidden = true;
            }
            function pick(saysAi) {
                if (busy) return;
                busy = true;
                bAi.disabled = bHu.disabled = true;
                var isAi = !!truth[i];
                var ok = saysAi === isAi;
                if (ok) right++;
                verdict.className = 'ai-verdict ' + (ok ? 'is-ok' : 'is-bad');
                verdict.appendChild(api.el('b', null, isAi ? api.tt('ah_was_ai') : api.tt('ah_was_human')));
                if (t.why && t.why[i]) verdict.appendChild(api.richEl('p', null, t.why[i]));
                if (i < items.length - 1) {
                    next.hidden = false;
                    try { next.focus({ preventScroll: true }); } catch (_) {}
                } else {
                    var score = items.length ? right / items.length : 1;
                    api.answer({
                        correct: score >= (step.pass || 0.6) - 1e-9,
                        score: score,
                        explain: api.fmt(api.tt('ah_score'), { n: right, total: items.length }) + (t.explain ? '\n\n' + t.explain : '')
                    });
                }
            }
            bAi.addEventListener('click', function () { pick(true); });
            bHu.addEventListener('click', function () { pick(false); });
            next.addEventListener('click', function () { i++; show(); });
            api.onKey(function (k) {
                if (k === '1') { if (!bAi.disabled) bAi.click(); return true; }
                if (k === '2') { if (!bHu.disabled) bHu.click(); return true; }
                return false;
            });
            show();
        }
    });

    /* ── задание в нашем туле ───────────────────────────────────────── */
    K.step('tool-task', {
        graded: false,
        mount: function (host, step, api) {
            var t = T(step);
            if (t.title) host.appendChild(api.el('h3', null, t.title));
            if (t.task) host.appendChild(exampleCard(api, api.tt('tt_task'), t.task, 'ai-task'));
            var tool = null;
            (step.tools || []).some(function (s) {
                if (TOOLS[s] && TOOLS[s].url) { tool = TOOLS[s]; return true; }
                return false;
            });
            if (tool) {
                api.body(host, t.body || []);
                var link = api.el('a', 'lg-btn ai-tool-link', '↗ ' + api.fmt(api.tt('tt_open'), { title: tool.title }));
                link.href = tool.url;
                link.target = '_blank';
                link.rel = 'noopener';
                link.addEventListener('click', function () {
                    try { if (window.__ae) window.__ae('course_tool_open', { course: api.slug, tool: tool.slug }); } catch (_) {}
                });
                var row = api.el('div', 'crs-acts');
                row.appendChild(link);
                host.appendChild(row);
                if (t.note) host.appendChild(api.richEl('p', 'crs-hint', t.note));
            } else {
                host.appendChild(api.el('p', 'crs-hint', api.tt('tt_offline')));
                api.body(host, t.offline || t.body || []);
            }
            var box = api.el('div', 'crs-practice');
            host.appendChild(box);
            api.primary(api.tt('tt_done'), function () {
                api.primary(null, null);
                box.appendChild(api.el('p', 'crs-prompt', t.done_q || api.t('self_q')));
                var r = api.el('div', 'crs-self');
                [['self_yes', 1], ['self_almost', 0.5], ['self_no', 0]].forEach(function (x) {
                    var b = api.el('button', 'lg-btn lg-btn-ghost', api.t(x[0]));
                    b.type = 'button';
                    b.addEventListener('click', function () {
                        api.store.set('self:' + step._lesson + '/' + step.id, x[1]);
                        var msg = x[1] === 1 ? (t.after_yes || api.t('self_yes_tx')) : x[1] === 0.5 ? (t.after_almost || api.t('self_almost_tx')) : (t.after_no || api.t('self_no_tx'));
                        api.answer({ correct: null, explain: msg });
                    });
                    r.appendChild(b);
                });
                box.appendChild(r);
            });
            api.secondary(api.t('skip'), function () { api.skip(); });
        }
    });
})();
